import { CheckboxWithLabel, CheckboxWithLabelProps } from 'formik-mui';

export const CustomCheckbox = (props: CheckboxWithLabelProps) => <CheckboxWithLabel color="secondary" {...props} />;
